import React from "react";
import Info from "./Info";

function Contact() {
  return (
    <section id="contact" className="py-5 overflow-hidden  ">
      <div className="container mt-5 mb-5">
        <small
          className="text-secondary fw-bold text-uppercase fs-5"
          data-aos="fade-up"
        >
          Contact
        </small>
        <h3 className="mt-2 fs-4 fw-bolder mb-5" data-aos="fade-up">
          Don't be shy! Hit me up! 👇
        </h3>
        <div className="d-flex align-items-center flex-wrap gap-5 gap-md-6 ">
          <Info
            name="Location"
            content={{ title: "Location", content: "Zarzis, Tunisia" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="tabler-icon tabler-icon-map-search"
            >
              <path d="M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v7.5"></path>
              <path d="M9 4v13"></path>
              <path d="M15 7v5"></path>
              <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
              <path d="M20.2 20.2l1.8 1.8"></path>
            </svg>
          </Info>
          <Info
            name="Mail"
            content={{ title: "Mail", content: "Medalisraieb@gmail.com" }}
            link
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="tabler-icon tabler-icon-mail"
            >
              <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"></path>
              <path d="M3 7l9 6l9 -6"></path>
            </svg>
          </Info>
        </div>
      </div>
    </section>
  );
}

export default Contact;
